import { ImageTemplate } from "../template";
import { ImageProps } from "..";
import Background1x from "./background-1x.jpg";
import Background2x from "./background-2x.jpg";

export const BackgroundImage = ({
  height,
  width,
  highResolution,
  ...props
}: ImageProps): JSX.Element => {
  return (
    <div style={{ height, width }}>
      <ImageTemplate
        {...props}
        imgSrc={highResolution ? Background1x : Background2x}
      />
    </div>
  );
};
